import { render, staticRenderFns } from "./ModalDenunce.vue?vue&type=template&id=4e45631a"
import script from "./ModalDenunce.vue?vue&type=script&lang=js"
export * from "./ModalDenunce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports